import { jsx as _jsx } from "react/jsx-runtime";
import { Update } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { memo, useEffect, useMemo } from 'react';
import { useUpdateRfIndicators } from '../../../panels/rf-indicators/utils';
import { getPanelName } from '../../../panels/utils';
import { TabPanelLayout } from '../layout';
export const RfIndicatorsPanel = (Panel) => memo(function RfIndicatorsPanel(props) {
    const { panel_key, config } = props;
    const name = useMemo(() => getPanelName(panel_key, config.length), [config.length, panel_key]);
    const [onRequestRf, is_loading, rf_response] = useUpdateRfIndicators();
    useEffect(() => {
        onRequestRf();
    }, []);
    const current_rf_indicators = useMemo(() => {
        return config.map((rf_indicator_config) => {
            const rf_indicator_response = rf_response.find((rf) => rf.slot === rf_indicator_config.slot);
            const current_rf_indicator = {
                ...rf_indicator_config,
                is_loading,
                ...(rf_indicator_response && {
                    serial: rf_indicator_response.serial,
                    time: rf_indicator_response.time,
                }),
            };
            return current_rf_indicator;
        });
    }, [config, is_loading, rf_response]);
    return (_jsx(TabPanelLayout, { panel_key: panel_key, title: name, additional_view: _jsx(LoadingButton, { loading: is_loading, onClick: onRequestRf, variant: "outlined", startIcon: _jsx(Update, {}), children: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C" }), children: _jsx(Panel, { ...props, config: current_rf_indicators, is_loading: is_loading }) }));
});
